import { Injectable } from "@angular/core";
import { AbstractTranslatableAlertService } from "@obg/ngx.core";

import { LoginLimitReminderContainer } from "./login-limit-reminder.container";
import { LOGIN_LIMIT_REMINDER_ALERT_ID } from "./login-limit-reminder.model";

@Injectable({
	providedIn: "root",
})
export class LoginLimitReminderService {
	constructor(private alertService: AbstractTranslatableAlertService) {}

	openZhhLoginLimitReminderAlert() {
		return this.alertService.open(
			{
				id: LOGIN_LIMIT_REMINDER_ALERT_ID,
				hideClose: false,
				messageComponent: LoginLimitReminderContainer,
				dialogConfig: {
					closeOnNavigation: false,
					panelClass: "zhh-login-limit-alert",
				},
			},
			[]
		);
	}
}
